module.exports = __webpack_public_path__ + "assets/webgl/Assets_2_base_color_L0.5588240b.jpg";